import { createSlice } from '@reduxjs/toolkit'

const loginSlice = createSlice({
    name: "log",
    initialState: {},
    reducers: {
        login(state, action) {
            state.username = action.payload.username
            state.email = action.payload.email
            state.id = action.payload.id
            state.profile_pic = action.payload.profile_pic
            state.user_role = action.payload.user_role
        },
        logout(state) {
            const allKeys = Object.keys(state);
            allKeys.forEach((key) => {
                delete state[key]
            })


        },

    }
})

export const { login, logout } = loginSlice.actions
export default loginSlice.reducer;

